module.exports = __webpack_public_path__ + "img/duo-acustico-aperitivo.fa158e2b.jpg";